exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li {\n  position: relative;\n  height: 7rem;\n  padding-left: 2.5rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  cursor: pointer;\n  transition: all 0.4s; }\n  li:hover {\n    background-color: #039be6; }\n    li:hover i, li:hover span {\n      color: #fff; }\n    li:hover .active {\n      background-color: #fff; }\n  li .active {\n    display: inline-block;\n    width: 1rem;\n    height: 100%;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    transition: all 0.4s; }\n  li i {\n    color: #989a9d;\n    font-size: 3rem;\n    transition: all 0.4s; }\n  li span {\n    color: #989a9d;\n    font-size: 2.4rem;\n    margin-left: 2.5rem;\n    transition: all 0.4s; }\n\n:host(.active-menu-item) li {\n  background-color: #039be6; }\n  :host(.active-menu-item) li i, :host(.active-menu-item) li span {\n    color: #fff; }\n  :host(.active-menu-item) li .active {\n    background-color: #fff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/app/core/menu/menu-item/menu-item.component.scss
// module id = ../../../../../src/app/core/menu/menu-item/menu-item.component.scss
// module chunks = 2